export const parseValueFromSchema = (value: any, type?: string) => {
  let displayValue = null

  if (typeof value === 'object' && value !== null) {
    const keys = Object.keys(value)
    const hasNameOrTitle = keys.some(
      (item) => item === 'name' || item === 'title' || item === 'email',
    )

    if (hasNameOrTitle) {
      const realValue = value['name'] || value['title'] || value['email']

      displayValue =
        typeof realValue === 'object' && realValue !== null && 'en' in realValue
          ? realValue.en
          : realValue

      return displayValue
    }

    for (const key in value) {
      if (typeof value[key] === 'string') {
        displayValue = value[key]
        break
      }

      if (
        typeof value[key] === 'object' &&
        value[key] !== null &&
        Object.keys(value[key]).length === 2 &&
        Object.values(value[key]).every((v) => typeof v === 'number')
      ) {
        const values = Object.values(value[key])
        displayValue = `${values[0]}, ${values[1]}`
        break
      }
    }

    if (displayValue === null) {
      displayValue = 'id: ' + value.id + (type ? ' of type: ' + type : '')
    }
  } else {
    displayValue = value
  }

  return displayValue
}
